module.exports = __webpack_public_path__ + "img/img_shouchi@2x.0cb9b7ba.png";